import { useState } from "react";
import SportFilter from "./SportFilter";
import DateFilter from "./DateFilter";
import SearchFilter from "./SearchFilter";
import styles from "./Filters.module.css";
import calendarIcon from "img/calendar-alt-regular.svg";
import { Dates, FiltersType } from "types/filters";

interface Props {
	sendFilters: (v: FiltersType) => void;
}
export default function Filters({ sendFilters }: Props) {
	const [searchQuery, setSearchQuery] = useState("");
	const [dateFiltersToggled, setDateFiltersToggled] = useState(false);

	const [sportFilters, setSportFilters] = useState<string>("");
	const [dateFilters, setDateFilters] = useState<Dates>({
		startDate: null!,
		endDate: null!,
	});

	const onSportChange = (value: string) => {
		sendFilters({
			dates: parseDateFilters(dateFilters),
			sports: value,
			searchQuery: searchQuery,
		});
		setSportFilters(value);
	};
	const onDateChange = (value: Dates) => {
		sendFilters({
			dates: parseDateFilters(value),
			sports: sportFilters,
			searchQuery: searchQuery,
		});
		setDateFilters(value);
	};
	const onSearchChange = (value: string) => {
		sendFilters({
			dates: parseDateFilters(dateFilters),
			sports: sportFilters,
			searchQuery: value,
		});
		setSearchQuery(value);
	};

	const parseDateFilters = (dates: any) => {
		let endDate = "";
		let startDate = "";
		if (dates.endDate instanceof Date && !isNaN(dates.endDate.valueOf())) {
			endDate = dates.endDate.toISOString();
		}
		if (dates.startDate instanceof Date && !isNaN(dates.startDate.valueOf())) {
			startDate = dates.startDate.toISOString();
		}
		return { endDate: endDate, startDate: startDate };
	};

	return (
		<div className={styles.filters}>
			<div className={styles.topRow}>
				<SportFilter selected={sportFilters} onChange={(sportID) => onSportChange(sportID)} />

				<SearchFilter onChange={(search) => onSearchChange(search)} />

				<button type="button" className={styles.dateToggler} onClick={() => setDateFiltersToggled(!dateFiltersToggled)}>
					<img src={calendarIcon} alt="Date filters" />
				</button>
			</div>
			{dateFiltersToggled ? (
				<DateFilter
					onChange={(dates: Dates) => onDateChange(dates)}
					dates={dateFilters}
					onClose={() => setDateFiltersToggled(false)}
				/>
			) : null}
		</div>
	);
}
